
import { defineComponent, computed, PropType } from '@vue/composition-api';
import { FCButton } from '@fc/angie-ui';
import { IVariant } from '~/types/fightcamp';

export default defineComponent({
  name: 'CartItem',
  components: {
    FCButton,
  },
  props: {
    item: {
      type: Object as PropType<IVariant>,
      required: true,
    },
    enableRemove: Boolean,
  },
  setup(props) {
    const packageSet = new Set([
      'trackers_S',
      'trackers_L',
      'trackers_with_bag_S',
      'trackers_with_bag_L',
    ]);
    const isPackage = computed(() => packageSet.has(props.item.id));
    const getPackagePath = computed(() => {
      if (props.item.id === 'trackers_S' || props.item.id === 'trackers_L') return '/shop/products/fightcamp-trackers/';
      return '/shop/products/fightcamp-trackers-bag/';
    });

    // @ts-ignore
    const { $store } = useNuxtApp();
    const gqSet = new Set([
      'gq_fightcamp_trackers_S',
      'gq_fightcamp_trackers_L',
      'pt_fightcamp_trackers_S',
      'pt_fightcamp_trackers_L',
    ]);
    const isNotGQPkgItem = computed(() => !gqSet.has(props.item.id) && $store.getters.isGQOrder);

    return {
      getPackagePath,
      isPackage,
      isIncludedItems: computed(() => props?.item?.items?.length > 0 ?? false),
      totalItemPrice: computed(() => props.item.price * props.item.qty),
      isNotGQPkgItem,
    };
  },
});
